import template from './privileges.html'

class PrivilegesPageVM
{
	constructor (dialog, page)
	{
		this.dialog = dialog;
		this.page = page;

		this.acl_object_types = ko.observableArray();


	}


}

class PrivilegesPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new PrivilegesPageVM(this);
	}

	async init ()
	{
	}

	async updateData ()
	{
	}

}

//Assign Page(HTML/JS) to Grape
export default {
	route: '[/]ui/admin/acl-privileges',
	page_class: PrivilegesPage,
	template: template
}
